// extracted by mini-css-extract-plugin
var _1 = "EntityProfileHeaderInfoItemLoading-modulecontentSkeleton__Vi4QX";
var _2 = "EntityProfileHeaderInfoItemLoading-moduleskeleton__dLQyH Skeleton-moduleSkeleton__Mlrfv";
var _3 = "EntityProfileHeaderInfoItemLoading-moduletitleSkeleton__Y74fF";
export { _1 as "contentSkeleton", _2 as "skeleton", _3 as "titleSkeleton" }
